import { Epic } from 'redux-observable';
import { catchError, map, mergeMap, debounceTime } from 'rxjs/operators';
import { TrackEvent } from '@alycecom/services';
import { ofType } from '@alycecom/utils';

import {
  finishInfoRequest,
  finishInfoSuccess,
  finishInfoFail,
  finishInfoSendRequest,
  finishInfoSendSuccess,
  finishInfoSendFail,
} from './finishInfo.actions';
import { ILoadFinishInfoResponse } from './finishInfo.types';

export const loadFinishInfoEpic: Epic = (action$, state$, { apiService, messagesService: { errorHandler } }) =>
  action$.pipe(
    ofType(finishInfoRequest),
    debounceTime(300),
    mergeMap(({ payload: { hashId } }) =>
      apiService.get(`/api/recipient/${hashId}/finish-message`).pipe(
        map((payload: ILoadFinishInfoResponse) => finishInfoSuccess(payload)),
        catchError(errorHandler({ callbacks: finishInfoFail })),
      ),
    ),
  );

export const sendFinishInfoEpic: Epic = (action$, state$, { apiService, messagesService: { errorHandler } }) =>
  action$.pipe(
    ofType(finishInfoSendRequest),
    debounceTime(300),
    mergeMap(({ payload: { hashId, message, product } }) =>
      apiService.post(`/api/recipient/${hashId}/finish-message`, { body: { message } }).pipe(
        mergeMap(() => [
          TrackEvent.actions.trackEvent({
            name: 'Need More Info Page - More info sent',
            payload: { hashId, message, product },
          }),
          finishInfoSendSuccess(),
        ]),
        catchError(errorHandler({ callbacks: finishInfoSendFail })),
      ),
    ),
  );

export const finishInfoEpics = [loadFinishInfoEpic, sendFinishInfoEpic];
